import { Box, Grid, Typography } from "@mui/material";
import { Outlet } from "react-router-dom";
import { useOAS } from "../../../context/SuperAdmin/OASContexts/OASContext";
import OASSidebar from "./OASSidebar";
import { Spinner } from "../../Loading/Spinner";
import { useEffect, useState } from "react";

const OASPanel = () => {
  const { isLoadingOthers, organizacion, tiposObjetivo } = useOAS();

  // Define si la organización elegida puede mostrar OAS por organizaicón o no
  const [allowedOrgOAS, setAllowedOrgOAS] = useState(false);

  useEffect(() => {
    if (organizacion && tiposObjetivo?.length > 0) {
      // buscar el tipo con código "ORG"
      const orgTipo = tiposObjetivo.find((t) => t.codigo === "ORG");

      if (orgTipo) {
        // validar si el id_tipo_objetivo está dentro de organizacion.tipo_objetivo (string[])
        const isAllowed = organizacion.tipo_objetivo.includes(
          orgTipo.id_tipo_objetivo
        );
        setAllowedOrgOAS(isAllowed);
      } else {
        setAllowedOrgOAS(false);
      }
    }
  }, [organizacion, tiposObjetivo]);

  if (isLoadingOthers) {
    return (
      <Grid item>
        <Spinner msg="Cargando por favor espere..." />
      </Grid>
    );
  }
  return allowedOrgOAS ? (
    <Grid
      item
      sx={{
        display: "flex",
        gap: 3,
        minHeight: "100%",
      }}
    >
      <OASSidebar />
      <Outlet />
    </Grid>
  ) : (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100%",
        textAlign: "center",
        color: "#336B87",
      }}
    >
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        ¡Lo siento!
      </Typography>
      <Typography variant="body1" gutterBottom>
        Tu organización no tiene habilitado la función de{" "}
        <b>OAS por organización</b>.
      </Typography>
      <Typography variant="body2">
        Habla con el administrador de la organización para habilitarla.
      </Typography>
    </Box>
  );
};

export default OASPanel;
